import {
    ColoursObj,
    Icon,
    TEventrIcons,
    Typography,
} from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'

interface ISectionEditProps {
    headerIcon?: TEventrIcons
    headerText?: string
}

export const SectionEdit = ({ headerText, headerIcon }: ISectionEditProps) => {
    return (
        <Stack>
            <Box
                borderRadius={'8px'}
                height={'56px'}
                bgcolor={ColoursObj.backgrounds.secondary}
            >
                <Stack padding={'16px'} direction={'row'} spacing={'8px'}>
                    <Icon
                        name={headerIcon}
                        iconColour={ColoursObj.core.secondary}
                    />
                    <Typography
                        variant="bodyBold"
                        id="BookingDetails"
                        color={ColoursObj.font.primary}
                    >
                        {headerText}
                    </Typography>
                </Stack>
            </Box>
        </Stack>
    )
}
